export default "__VITE_ASSET__1a096424__"